import vm from "@/vue";

vm.$mount("#app");
